import { Box, Flex, Select, Text } from '@chakra-ui/react';
import React from 'react'
import { MdOutlineFileDownload } from 'react-icons/md';
import CustomTablePage2 from './CustomTablePage2';

const MemberUploadDataTable = ({memberData}) => {
    console.log('memberData', memberData)
    const tableProps = {
        data: memberData,
        title: {
          membershipId: 'Membership ID',
          fullName: "Full Name",
          email: "Email Address",
          membershipCategory: "Membership Category",
          entryYear: "Entry Year",
          dateOfBirth: 'Date Of Birth',
          stateOfOrigin: 'State of Origin',
          maritalStatus: 'Marital Status',
          gender: 'Gender',
          address: 'Address',
          phoneNumber: 'Phone Number',
        },
        dataKeys: [
          "membershipId",
          "fullName",
          "email",
          "membershipCategory",
          "entryYear",
          "dateOfBirth",
          "stateOfOrigin",
          "maritalStatus",
          "gender",
          "address",
          "phoneNumber",
        ],
        transformRow: (item) => ({
          membershipId: <div>{item?.membershipId}</div>,
          fullName:<div>{item?.title} {item?.firstName} {item?.otherName} {item?.lastName}</div>,
          email:<div>{item?.email}</div>,
          membershipCategory:<div>{item?.membershipCategoryString}</div>,
          entryYear:<div>{item?.entryYear}</div>,
          dateOfBirth:<div>{item?.dateOfBirth}</div>,
          stateOfOrigin:<div>{item?.stateOfOrigin}</div>,
          maritalStatus:<div>{item?.maritalStatus}</div>,
          gender:<div>{item?.gender}</div>,
          address:<div>{item?.homeAddress} {item?.country}</div>,
          phoneNumber:<div>{item?.phoneNumber}</div>,
          }),
      };
  return (
    <Box py={'30px'} minH={'100vh'} bgColor={'#FFF'}>
      <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} gap={'20px'} px={'20px'} mb={2}>
        <Text fontSize={'18px'} fontWeight={'700'} color={'rgba(209, 26, 42, 0.5)'} >Member Data</Text>
        <Flex alignItems={'center'} justifyContent={'center'} flexDirection={["column", "column", "row"]} gap={[3, null, null]} >
          <Select placeholder='Sort by' onFocusBorderColor=''>
            <option value='option1'>Option 1</option>
            <option value='option2'>Option 2</option>
            <option value='option3'>Option 3</option>
          </Select>
          <Flex alignItems={'center'} _hover={{ color: '#D11A2A' }} cursor={'pointer'}>
            <Text fontSize={'14px'} fontWeight={500} color={'#404040'} w={'100px'} _hover={{ color: '#D11A2A' }}>CSV download</Text>
            <MdOutlineFileDownload />
          </Flex>
        </Flex>
      </Flex>
      <CustomTablePage2 {...tableProps} />
    </Box>
  )
}

export default MemberUploadDataTable